module.exports = __webpack_public_path__ + "img/ssb_menu8.9d5a3579.png";